import React, { useState, createContext, useContext } from "react";
import { useAuth } from "./AuthContext";
import { Button } from "../components/ui/button";
import { CheckCircle, Edit } from "lucide-react";

// Admin Edit Context
const AdminEditContext = createContext(null);

export const useAdminEdit = () => useContext(AdminEditContext);

export const AdminEditProvider = ({ children }) => {
  const { user } = useAuth();
  const [editMode, setEditMode] = useState(false);
  const [editingItem, setEditingItem] = useState(null);
  
  const isAdmin = user?.user_type === "admin";
  
  const toggleEditMode = () => {
    if (isAdmin) setEditMode(!editMode);
  };
  
  return (
    <AdminEditContext.Provider value={{ editMode, toggleEditMode, isAdmin, editingItem, setEditingItem }}>
      {children}
      {isAdmin && (
        <div className="fixed bottom-20 right-4 z-[9999]" data-testid="admin-edit-button">
          <Button
            onClick={toggleEditMode}
            className={`rounded-full w-14 h-14 shadow-lg ${editMode ? 'bg-green-600 hover:bg-green-700' : 'bg-[#002147] hover:bg-[#003366]'}`}
          >
            {editMode ? <CheckCircle size={24} /> : <Edit size={24} />}
          </Button>
          {editMode && (
            <div className="absolute bottom-16 right-0 bg-white rounded-lg shadow-xl p-3 w-48">
              <p className="text-sm font-semibold text-green-600 mb-2">Edit Mode ON</p>
              <p className="text-xs text-gray-500">Click any editable item to modify</p>
            </div>
          )}
        </div>
      )}
    </AdminEditContext.Provider>
  );
};

export default AdminEditContext;
